// import { useQuery } from '@tanstack/react-query';
// import { adminServices } from 'features/admin/services/admin.service';

// export const useAdmins = ({ page, limit, status, role, search, sortBy, sortOrder, twoFactorAuth }) => {
//   return useQuery({
//     queryKey: ['admins', { page, limit, status, role, search, sortBy, sortOrder, twoFactorAuth }],
//     queryFn: () =>
//       adminServices.getAdmins({
//         page,
//         limit,
//         status,
//         role,
//         search,
//         sortBy,
//         sortOrder,
//         twoFactorAuth,
//       }),
//     staleTime: 5 * 60 * 1000, // 5 minutes
//     gcTime: 10 * 60 * 1000, // 10 minutes
//     keepPreviousData: true,
//   });
// };

// export const useAdmin = (adminId) => {
//   return useQuery({
//     queryKey: ['admins', adminId],
//     queryFn: () => adminServices.getAdminById(adminId),
//     enabled: !!adminId,
//     staleTime: 5 * 60 * 1000,
//   });
// };

// export const useRoles = () => {
//   return useQuery({
//     queryKey: ['roles'],
//     queryFn: () => adminServices.getRoles(),
//     staleTime: 10 * 60 * 1000, // 10 minutes
//   });
// };


import { useQuery } from '@tanstack/react-query';
import { adminServices } from 'features/admin/services/admin.service';

/**
 * Reusable API error parser
 */
const parseApiError = (error) => {
  return {
    message:
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.message ||
      'Something went wrong',

    status: error?.response?.status || 500,

    errors: error?.response?.data?.errors || [],
  };
};

/**
 * Get all admins
 */
export const useAdmins = ({
  page,
  limit,
  status,
  role,
  search,
  sortBy,
  sortOrder,
  twoFactorAuth,
}) => {
  return useQuery({
    queryKey: [
      'admins',
      {
        page,
        limit,
        status,
        role,
        search,
        sortBy,
        sortOrder,
        twoFactorAuth,
      },
    ],

    queryFn: async () => {
      try {
        return await adminServices.getAdmins({
          page,
          limit,
          status,
          role,
          search,
          sortBy,
          sortOrder,
          twoFactorAuth,
        });
      } catch (error) {
        throw parseApiError(error);
      }
    },

    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes

    placeholderData: (previousData) => previousData,

    retry: 1,
  });
};

/**
 * Get single admin by ID
 */
export const useAdmin = (adminId) => {
  return useQuery({
    queryKey: ['admins', adminId],

    queryFn: async () => {
      try {
        return await adminServices.getAdminById(adminId);
      } catch (error) {
        throw parseApiError(error);
      }
    },

    enabled: !!adminId,

    staleTime: 5 * 60 * 1000,

    retry: 1,
  });
};

/**
 * Get all roles
 */
export const useRoles = () => {
  return useQuery({
    queryKey: ['roles'],

    queryFn: async () => {
      try {
        return await adminServices.getRoles();
      } catch (error) {
        throw parseApiError(error);
      }
    },

    staleTime: 10 * 60 * 1000, // 10 minutes

    retry: 1,
  });
};